export default __webpack_public_path__ + "static/media/bigbazaar.1cf5169e.png";